const queen = {
  vuePictureCut: [],
  vcrontab: [],
  quill: []
};

/**
 * 引入vuePictureCut
 * @param cb
 */
export function loadVuePictureCut(cb, error) {
  if (window['vue-picture-cut']) {
    cb(window['vue-picture-cut']);
  } else if (queen.vuePictureCut.length > 0) {
    queen.vuePictureCut.push(cb);
  } else {
    queen.vuePictureCut.push(cb);
    dsf.http
      .importFiles([
        dsf.url.getWebPath("$/js/libs/vuePictureCut/vue-picture-cut.css"),
        dsf.url.getWebPath("$/js/libs/vuePictureCut/vue-picture-cut.umd.min.js"),
      ])
      .then(() => {
        window.Vue.use(window['vue-picture-cut'].default);
        _.each(queen.vuePictureCut, q => q?.(window['vue-picture-cut']));
        queen.vuePictureCut.length = 0;
      })
      .catch((err) => {
        dsf.error(err);
        dsf.layer.message("加载vuePictureCut脚本出错", false);
        error?.(err);
      });
  }
}

/**
 * 引入vcrontab
 * @param cb
 */
export function loadVcrontab(cb, error) {
  if (window['vcrontab']) {
    cb(window['vcrontab']);
  } else if (queen.vcrontab.length > 0) {
    queen.vcrontab.push(cb);
  } else {
    queen.vcrontab.push(cb);
    dsf.http
      .importFiles([
        dsf.url.getWebPath("$/js/libs/vcrontab/vcrontab.umd.min.js"),
      ])
      .then(() => {
        window.Vue.use(window['vcrontab'].default);
        _.each(queen.vcrontab, q => q?.());
        queen.vcrontab.length = 0;
      })
      .catch((err) => {
        dsf.error(err);
        dsf.layer.message("加载vcrontab脚本出错", false);
        error?.(err);
      });
  }
}

/**
 * 引入quill
 * @param cb
 */
export function loadQuill(cb, error) {
  if (window['VueQuillEditor']) {
    cb(window['VueQuillEditor']);
  } else if (queen.quill.length > 0) {
    queen.quill.push(cb);
  } else {
    queen.quill.push(cb);
    dsf.http
      .importFiles([
        dsf.url.getWebPath("$/js/libs/quill/quill.core.css"),
        dsf.url.getWebPath("$/js/libs/quill/quill.snow.css"),
        dsf.url.getWebPath("$/js/libs/quill/quill.bubble.css"),
        dsf.url.getWebPath("$/js/libs/quill/quill.js"),
        dsf.url.getWebPath("$/js/libs/quill/vue-quill-editor.js"),
      ])
      .then(() => {
        window.Vue.use(window['VueQuillEditor']);
        _.each(queen.quill, q => q?.());
        queen.quill.length = 0;
      })
      .catch((err) => {
        dsf.error(err);
        dsf.layer.message("加载quill脚本出错", false);
        error?.(err);
      });
  }
}